export interface DeXuatNhuCauTaiSan {
    id?: number;
    idCaNhan: number;
    hoTenCaNhan?: string;
    idLanhDaoPhong: number;
    tenLanhDaoPhong?: string;
    idDonVi: number;
    tenDonVi?: string;
    
    loaiNhuCau: number;
    idTaiSan?: number;
    maTaiSan?: string;
    tenTaiSan?: string;
    soLuong?: number;
    donViTinh?: string;
    tinhTrangTaiSan?: string;
    phanLoaiTaiSan?: number;
    tenPhanLoaiTaiSan?: string;
    moTa?: string;
    trangThai: number;
    
    idPhoCVP?: number;
    tenPhoCVP?: string;
    idCVP?: number;
    tenCVP?: string;
    idPhoGiamDoc?: number;
    tenPhoGiamDoc?: string;
    idGiamDoc?: number;
    tenGiamDoc?: string;
    
    noiDungThamMuu?: string;
    idCVVPThamMuu?: number;
    tenCVVPThamMuu?: string;
    ngayThamMuu?: Date;
    
    lyDoTraLai?: string;
    ngayTrinh?: Date;
    ngayDuyet?: Date;
    ngayDuyetLanhDaoPhong?: Date;
    ngayDuyetPhoCVP?: Date;
    ngayDuyetCVP?: Date;
    ngayDuyetPhoGiamDoc?: Date;
    ngayDuyetGiamDoc?: Date;
    ngayKhoiTao?: Date;
    idNVKhoiTao?: number;
    tinhTrang?: number;
    duongDanFileIn?: string;
    tenFileIn?: string;
}

export interface DeXuatNhuCauTaiSanRequest {
    id?: number;
    idLanhDaoPhong: number;
    loaiNhuCau: number;
    idTaiSan?: number;
    tenTaiSan?: string;
    soLuong?: number;
    donViTinh?: string;
    tinhTrangTaiSan?: string;
    phanLoaiTaiSan?: number;
    moTa?: string;
    noiDungThamMuu?: string;
    idPhoCVP?: number;
    idCVP?: number;
    idPhoGiamDoc?: number;
    idGiamDoc?: number;
}

export enum PhanLoaiTaiSanNhuCau {
    TSCD = 1,
    CCDC = 3
}

// Trạng thái đề xuất nhu cầu tài sản
export enum TrangThaiDeXuatNhuCau {
    KhoiTao = 0,
    ThuHoi = 1,
    TrinhLanhDaoPhong = 2,
    LanhDaoPhongTraLai = 3,
    ChuyenChanhVP = 4,
    ChanhVPTraLai = 5,
    CVVPThamMuu = 6,
    CVVPTraLai = 7,
    TrinhPhoCVP = 8,
    PhoCVPTraLai = 9,
    TrinhCVP = 10,
    CVPTraLai = 11,
    TrinhPhoGiamDoc = 12,
    PhoGiamDocTraLai = 13,
    TrinhGiamDoc = 14,
    GiamDocTraLai = 15,
    PheDuyet = 16
}

// Loại nhu cầu tài sản
export enum LoaiNhuCauTaiSan {
    MuaMoi = 1,
    BanGiao = 2,
    SuaChua = 3,
    DieuChuyen = 4
}
